import { render, staticRenderFns } from "./UpdateMapper.vue?vue&type=template&id=1af6823a&scoped=true"
import script from "./UpdateMapper.vue?vue&type=script&lang=js"
export * from "./UpdateMapper.vue?vue&type=script&lang=js"
import style0 from "./UpdateMapper.vue?vue&type=style&index=0&id=1af6823a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af6823a",
  null
  
)

export default component.exports